import React, {Component} from 'react'
import {Progress as AntProgress} from 'antd'

import style from  './style.sass'

class Progress extends Component {
  render() {
    return(
      <div
        className='card'
        styleName='wrapper'
      >
        <AntProgress type='circle' percent={this.props.percent}/>
      </div>
    )
  }
}

export default Progress
